import axios from 'axios'

let defaultURL = 'https://graph.facebook.com/v11.0/'+ process.env.VUE_APP_FB_PIXEL_ID

export default axios.create({
  baseURL: defaultURL
})
